<template>
  <div class="indicator-chart">
    <x-loading :visible="loading">
      <span
        class="indicator-chart-text"
        :style="calcStyle"
      >{{ indicator }}</span>
    </x-loading>
  </div>
</template>

<script>
import apis from '@/api'

export default {
  props: {
    chartConfig: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      indicator: 0,
      loading: false,
      queryParams: {}
    }
  },
  computed: {
    calcStyle() {
      let tarSty = {}
      if (this.chartConfig.fontSize === 'small') {
        tarSty.fontSize = '1.71rem'
      } else if (this.chartConfig.fontSize === 'large') {
        tarSty.fontSize = '2.86rem'
      } else {
        tarSty.fontSize = '2.29rem'
      }
      return tarSty
    }
  },
  created() {
    this.queryParams = this.$route.query
    this.queryData()
  },
  methods: {
    refresh() {
      console.log('刷新方法执行')
      this.queryData()
    },
    queryData() {
      const request = {
        ...apis.FORM.GET_CHART_DATA,
        params: {
          reportFormId: this.queryParams.formId,
          chartUuid: this.chartConfig.uuid
        }
      }
      this.loading = true
      this.$request(request).asyncThen(resp => {
        this.loading = false
        if (resp.code === 'ok') {
          this.indicator = resp.data.chartDatas[0].yaxisValues[0].value
        }
      }, (err) => {
        this.loading = false
      }).asyncErrorCatch(err => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
.indicator-chart {
  height: 4.57rem;
  .x-loading, .x-loading > img {
    margin: auto;
    height: 100%;
  }
  .x-loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .indicator-chart-text {
    font-weight: $--app-base-font-weight;
  }
}
</style>
